import * as React from "react";
import { toggleAllFunds } from "../../../actions";
import { IDataEntityResponse, IAppParams } from "../../../models";
import { addItemToGoogleTracking } from "../../../utils";

const styles = require('./ToggleButton.pcss');

interface IProps {
    toggleAllFunds: typeof toggleAllFunds;
    funds?: IDataEntityResponse;
    style?: object;
    appParams?: IAppParams;
}

export class ToggleButton extends React.Component<IProps, {}>{
    constructor(props) {
        super(props);

        this.doToggle = this.doToggle.bind(this);
    }

    doToggle(isExpand: boolean) {
        let { toggleAllFunds, appParams } = this.props;
        addItemToGoogleTracking(appParams, isExpand ? "fundWidgetExpand" : "fundWidgetCollapse", {});
        toggleAllFunds(isExpand);
    }

    render() {
        let { funds, style } = this.props;
        let isAllToggled = funds.values.filter((fund) => fund.collapsed);

        return (
            <div className={styles.expandButton} style={{ float: "left" }}>
                <span className={styles.toggle_button + ' ' + styles.toggle_button_left}>
                    <button onClick={ () => this.doToggle(true)} type="button" disabled={isAllToggled.length === 0}>EXPAND ALL</button>
                </span>
                <span className={styles.toggle_button + ' ' + styles.toggle_button_right}>
                    <button onClick={ () => this.doToggle(false)} type="button" disabled={isAllToggled.length === funds.values.length}>COLLAPSE ALL</button>
                </span>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/client/components/FundPages/ToggleButton/ToggleButton.tsx